import { render } from "./IndexProfile.vue?vue&type=template&id=df544304"
import script from "./IndexProfile.vue?vue&type=script&lang=js"
export * from "./IndexProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__